import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

export const useAddContentToTextSet = () => {
  const addTextSetContent = useCallback((payload) => {
    return new Request(`${API_BASE_URL}/api/v3/content-membership/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(addTextSetContent);
};

export default useAddContentToTextSet;
